<div class="for-fixed-component categories-list card base-shadow-list b-0">
    <div class="head-template">
        <div>
            Categories of questions
        </div>
        <app-modal-create></app-modal-create>
    </div>
    <div class="card-body search-template">
        <input type="search" value="" [(ngModel)]="searchText" />
        <i class="ti-search"></i>
    </div>
    <div slimScroll width="auto" height="446px" size="5px" alwaysVisible="true">
        <div *ngFor="let category of categories |  filter : ['name'] : searchText" class="title-category">
            <div [routerLink]="['/admin/question-list', category.id]" routerLinkActive="active-category" [ngClass]="{'active-category': selectedCategoryId===category.id}" (click)="changeCategory(category)">{{category.name}}</div>
            <div>
                <app-modal-edit [modalData]="category"></app-modal-edit>
                <app-modal-delete [modalData]="category"></app-modal-delete>
            </div>
        </div>
    </div>
</div>
